export const errorObjs = {
    1:"The above field can't be empty",
    2:"Invalid input"
    };